export default __webpack_public_path__ + "static/media/vaporwave.7290a0d4.jpg";